const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/strategy/manage/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { readLiveFlag } from '@/common/utils/readLiveFlag';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
import { objectiveIdSearchParam } from '@/features/objectives/searchSchema';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
interface StrategyManageBeforeLoadArgs {
  context: PermissionContext & {
    flagOverrides: Partial<FlagKeys>;
    flags: Partial<FlagKeys>;
    ldClient: LDClient | undefined;
  };
  params: {
    loopId: number;
    org: string;
  };
}
export async function strategyManageBeforeLoad(args: StrategyManageBeforeLoadArgs) {
  await requirePermission('view_loop')(args);
  const newStrategyViewEnabled = readLiveFlag(args.context, 'newStrategyViewEnabled');
  if (!newStrategyViewEnabled) {
    throw redirect({
      params: args.params,
      replace: true,
      to: '/org/$org/loop/$loopId/strategy'
    });
  }
}
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/strategy/manage/')({
  beforeLoad: strategyManageBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.strategy)
    }
  },
  validateSearch: zodValidator(itemPanelSearchSchema.extend({
    archived: z.boolean().optional().catch(undefined),
    objectiveId: objectiveIdSearchParam
  }))
});